/**
 * This file was copied from frontend-packages/tools/ci/scripts/transifex/templates/locales.index.ts.template
 * If you want to make changes to this file, consider changing the original.
 **/
import { Catalogs } from '@lingui/core';
import * as localeDE from '../locale/de/messages';
import * as localeEN from '../locale/en/messages';
import * as localeES from '../locale/es/messages';
import * as localeFR from '../locale/fr/messages';
import * as localePT from '../locale/pt/messages';
import * as localeHU from '../locale/hu/messages';
import * as localeIT from '../locale/it/messages';
import * as localeJA from '../locale/ja/messages';
import * as localeKO from '../locale/ko/messages';

const catalogs: Catalogs = {
    de: localeDE,
    en: localeEN,
    es: localeES,
    fr: localeFR,
    pt: localePT,
    hu: localeHU,
    it: localeIT,
    ja: localeJA,
    ko: localeKO,
};
export default catalogs;
